import * as backend from '@/api/backend';
import { checkResponseStatus } from '@/util/check';

const defaultInterest = {
  interestID: null,
  color: '#ffffff',
  backgroundColor: '#a5988d',
  text: '',
  timestamp: '',
};

export default {
  state: {
    interests: [],
    loading: false,
    error: false,
    interestEdit: {
      ...defaultInterest,
    },
    defaultInterest,
  },
  mutations: {
    fetch(state) {
      state.loading = true;
    },
    errorInterests(state) {
      state.interets = [];
      state.loading = false;
      state.error = true;
    },
    setInterests(state, interests) {
      state.interests = interests;
      state.loading = false;
      state.error = false;
    },
    editInterest(state, interest) {
      const formattedInterest = {
        ...interest,
      };

      Object.keys(state.interestEdit).forEach((key) => {
        state.interestEdit[key] = formattedInterest[key];
      });
    },
    updateInterest(state, interest) {
      Object.keys(interest).forEach((key) => {
        state.interestEdit[key] = interest[key];
      });
    },
  },
  actions: {
    async fetchInterests({ commit }) {
      commit('fetch');
      try {
        const response = await backend.getInterests();
        await checkResponseStatus(200, response);
        const json = response.data;
        const formattedJson = json.map((interest) => ({
          ...interest,
        }));
        commit('setInterests', formattedJson);
      } catch (e) {
        console.error(e);
        commit('errorInterests');
      }
    },
  },
  namespaced: true,
};
